import { Dropdown } from 'module/ui/components/atoms/dropdown/dropdown';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  border-radius: var(--border-radius-default);
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--spacing-03);
  max-width: 500px;
  width: 100%;
  height: 32px;
  border: 1px solid var(--scarlet-gray-40);
  color: var(--text-placeholder);
`;

const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 380px;
  color: var(--text-primary);
`;

const DropdownContent = styled.div`
  padding: 0;
  overflow: hidden;
  max-width: 700px;
  background: var(--white-100);
  border-radius: 8px;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

interface DropdownSelectorProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedLabel?: string;
  placeholder: ReactNode;
  dropdownContent: ReactNode;
}

export const DropdownSelector: React.FC<DropdownSelectorProps> = ({
  isOpen,
  onOpenChange,
  selectedLabel,
  placeholder,
  dropdownContent,
}) => {
  return (
    <Dropdown
      open={isOpen}
      trigger={['click']}
      onOpenChange={onOpenChange}
      dropdownRender={() => (
        <DropdownContent>{dropdownContent}</DropdownContent>
      )}
      overlay={<div />}
    >
      <Wrapper>
        <div style={{ flex: 1 }}>
          {selectedLabel ? (
            <EllipsisText>{selectedLabel}</EllipsisText>
          ) : (
            placeholder
          )}
        </div>
        <div style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </Wrapper>
    </Dropdown>
  );
};
